import { render, staticRenderFns } from "./SearchModalPositions.vue?vue&type=template&id=4528026e&scoped=true"
import script from "./SearchModalPositions.vue?vue&type=script&lang=js"
export * from "./SearchModalPositions.vue?vue&type=script&lang=js"
import style0 from "./SearchModalPositions.vue?vue&type=style&index=0&id=4528026e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528026e",
  null
  
)

export default component.exports